export enum UniversalTrackerModalShowAs {
  Chart = 'chart',
  Table = 'table',
  AddToDashboard = 'add-to-dashboard',
  TargetBaseline = 'target-baseline'
}

export interface UniversalTrackerModalTab {
  navId: UniversalTrackerModalShowAs;
  disabled?: boolean;
  name: string;
  component: JSX.Element;
}
